import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SettingsService } from '../../../core/services/settings.service';
import { NotificationService } from '../../../core/services/notification.service';
import { BillingSettingsDto } from '../../../core/models/billing-settings.model';

@Component({
  selector: 'app-billing-settings',
  imports: [CommonModule, FormsModule],
  templateUrl: './billing-settings.html',
  styleUrl: './billing-settings.scss',
})
export class BillingSettings implements OnInit {
  isLoading = false;
  isSaving = false;

  billing: BillingSettingsDto = {
    id: '',
    accountName: '',
    billingEmail: '',
    contactNumber: '',
    vatNumber: '',
    amountOwed: 0,
    nextBillingDate: new Date().toISOString().slice(0, 10),
    invoiceGenerationWeek: 4,
    debitDayOfMonth: 1,
  };

  constructor(
    private settingsService: SettingsService,
    private notificationService: NotificationService,
  ) {}

  ngOnInit(): void {
    this.loadBillingDetails();
  }

  private loadBillingDetails(): void {
    this.isLoading = true;

    this.settingsService.getClinicBilling().subscribe({
      next: (billing) => {
        this.billing = {
          ...billing,
          nextBillingDate: billing.nextBillingDate ?? new Date().toISOString().slice(0, 10),
          invoiceGenerationWeek: billing.invoiceGenerationWeek ?? 4,
          debitDayOfMonth: billing.debitDayOfMonth ?? 1,
        };
        this.isLoading = false;
      },
      error: (error) => {
        this.notificationService.error(
          'Failed to load billing settings: ' +
            (error?.error?.message || error.message || 'Unknown error'),
        );
        this.isLoading = false;
      },
    });
  }

  saveBillingDetails(): void {
    this.isSaving = true;

    this.settingsService.saveClinicBilling(this.billing).subscribe({
      next: (billing) => {
        this.billing = {
          ...billing,
          nextBillingDate: billing.nextBillingDate ?? this.billing.nextBillingDate,
          invoiceGenerationWeek:
            billing.invoiceGenerationWeek ?? this.billing.invoiceGenerationWeek,
          debitDayOfMonth: billing.debitDayOfMonth ?? this.billing.debitDayOfMonth,
        };
        this.notificationService.success('Billing settings saved successfully.');
        this.isSaving = false;
      },
      error: (error) => {
        this.notificationService.error(
          'Failed to save billing settings: ' +
            (error?.error?.message || error.message || 'Unknown error'),
        );
        this.isSaving = false;
      },
    });
  }
}
